import * as Mutations from './mutations';
import { NotificationTypes } from './notification.types';
import { Notification } from './notification.model';

const NOTIFICATION_DEFAULT_TIMER = 5000;
const NOTIFICATION_ANIMATION_DURATION = 800;

export const NotificationsModule = {
    state: {
        notifications: []
    },

    mutations: {
        [Mutations.ADD_NOTIFICATION] (state, notification) {
            state.notifications.push(notification);
        },

        [Mutations.REMOVE_NOTIFICATION] (state, id) {
            const index = state.notifications.findIndex(notification => notification.id === id);
            if (index > -1) {
                state.notifications.splice(index, 1);
            }
        },

        [Mutations.CLEAR_NOTIFICATIONS] (state) {
            state.notifications = [];
        }
    },

    actions: {
        createSuccessNotification(context, message) {
            const notification = new Notification(message, NotificationTypes.SUCCESS);
            context.dispatch('saveNotification', notification);
        },

        createErrorNotification(context, message) {
            const notification = new Notification(message, NotificationTypes.ERROR);
            context.dispatch('saveNotification', notification);
        },

        createWarningNotification(context, message) {
            const notification = new Notification(message, NotificationTypes.WARNING);
            context.dispatch('saveNotification', notification);
        },

        saveNotification(context, notification) {
            context.commit(Mutations.ADD_NOTIFICATION, notification);
            setTimeout(() => {
                context.dispatch('removeNotification', notification.id);
            }, notification.type.timer ? notification.type.timer : NOTIFICATION_DEFAULT_TIMER);
        },

        removeNotification(context, id) {
            context.commit(Mutations.REMOVE_NOTIFICATION, id);
        },

        createSingleErrorNotification(context, message) {
            context.commit(Mutations.CLEAR_NOTIFICATIONS);
            setTimeout(() => {
                context.dispatch('createErrorNotification', message);
            }, NOTIFICATION_ANIMATION_DURATION);
        }
    },

    getters: {
        notifications: state => state.notifications.reverse()
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/notifications/notifications.module.js